module.exports = __webpack_public_path__ + "img/result-detail-sacrifice-inright01.fbf23267.svg";